import { HttpInterceptorFn } from '@angular/common/http';
import { Preferences } from '@capacitor/preferences';
import { from, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  return from(
    Preferences.get({
      key: 'token',
    }),
  ).pipe(
    switchMap(({ value: token }) => {
      if (!token) return next(req);

      const { access_token } = JSON.parse(token);
      const accessToken = access_token ?? '';

      if (!accessToken) return next(req);

      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${accessToken}`,
          },
        }),
      );
    }),
  );
};
